import { Routes } from '@angular/router';
import { RegisterGuard } from './register/register.guard';

export const membershipRoutes: Routes = [
  {
    path: 'login',
    title: '會員登入',
    loadComponent: () =>
      import('./login/login.component').then((c) => c.LoginComponent),
  },
  {
    path: 'register',
    title: '會員註冊',
    loadComponent: () =>
      import('./register/register.component').then((c) => c.RegisterComponent),
    canDeactivate: [RegisterGuard]
  },
  {
    path: 'forgot-password',
    title: '忘記密碼',
    loadComponent: () =>
      import('./forgot-password/forgot-password.component').then(
        (c) => c.ForgotPasswordComponent
      ),
  },
  {
    path: 'reset-password',
    title: '重設密碼',
    loadComponent: () =>
      import('./reset-password/reset-password.component').then(
        (c) => c.ResetPasswordComponent
      ),
  },
  {
    path: 'binding',
    title: '綁定帳號',
    loadComponent: () =>
      import('./binding/binding.component').then(
        (c) => c.BindingComponent
      ),
  },
  {
    path: 'profile',
    title: '會員資料',
    loadComponent: () =>
      import('./profile/profile.component').then((c) => c.ProfileComponent),
  },
  {
    path: 'profile-edit',
    title: '編輯個人資料',
    loadComponent: () =>
      import('./profile-edit/profile-edit.component').then(
        (c) => c.ProfileEditComponent
      ),
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'login',
  }
]